import CONSTANTS from '../constants'
import { postRequest, getRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

// Calls the API to get user token
export const userLogin = (creds) => (dispatch) => {
  dispatch(addEventLog(creds, CONSTANTS.LOGIN_REQUEST))
  dispatch({ type: CONSTANTS.LOGIN_REQUEST })
  return postRequest(APICONFIG.getUserLoginUrl, creds).then((res) => {
    let resObject = { ...creds, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.LOGIN_SUCCESS))
    dispatch({ type: CONSTANTS.LOGIN_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...creds, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.LOGIN_FAILURE))
    dispatch({ type: CONSTANTS.LOGIN_FAILURE })
    return err
  })
}
export const userSingUp = (creds) => (dispatch) => {
  dispatch(addEventLog(creds, CONSTANTS.SINGUP_REQUEST))
  dispatch({ type: CONSTANTS.SINGUP_REQUEST })
  return postRequest(APICONFIG.singupUrl, creds).then((res) => {
    let resObject = { ...creds, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SINGUP_SUCCESS))
    dispatch({ type: CONSTANTS.SINGUP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...creds, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SINGUP_FAILURE))
    dispatch({ type: CONSTANTS.SINGUP_FAILURE })
    return err
  })
}


export const logoutRequest = () => {
  return (dispatch) => {
    dispatch({ type: CONSTANTS.LOGOUT_REQUEST })
  }
}
// Calls the API to get User-Profile Initials
export const getUserProfile = () => (dispatch) => {
  dispatch(addEventLog('nil', CONSTANTS.GET_USER_PROFILE_REQUEST))
  dispatch({ type: CONSTANTS.GET_USER_PROFILE_REQUEST })
  return getRequest(APICONFIG.getUserProfileUrl).then((res) => {
    let resObject = res 
    dispatch(addEventLog(resObject, CONSTANTS.GET_USER_PROFILE_SUCCESS))
    dispatch({ type: CONSTANTS.GET_USER_PROFILE_SUCCESS, data: res.data })
    return res.data
  }).catch((err) => {
    let errObject = err 
    dispatch(addEventLog(errObject, CONSTANTS.GET_USER_PROFILE_FAILURE))
    dispatch({ type: CONSTANTS.GET_USER_PROFILE_FAILURE })
  })
}

// Calls the API to get User-Profile Initials
export const getUserData = () => (dispatch) => {
  dispatch(addEventLog('', CONSTANTS.GET_USER_DATA_REQUEST))
  dispatch({ type: CONSTANTS.GET_USER_DATA_REQUEST })
  return getRequest(APICONFIG.getUserProfileData).then((res) => {
    let resObject = res
    dispatch(addEventLog(resObject, CONSTANTS.GET_USER_DATA_SUCCESS))
    dispatch({ type: CONSTANTS.GET_USER_DATA_SUCCESS, data: res.data })
    return res.data
  }).catch((err) => {
    let errObject = err 
    dispatch(addEventLog(errObject, CONSTANTS.GET_USER_DATA_FAILURE))
    dispatch({ type: CONSTANTS.GET_USER_DATA_FAILURE })
    return err
  })
}

// updated user-Profile
export const updateUserProfile = (data) => (dispatch) => {
  dispatch(addEventLog(data, CONSTANTS.UPDATE_USER_PROFILE_REQUEST))
  dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_REQUEST })
  return postRequest(APICONFIG.updateUserProfileUrl, data).then((res) => {
    let resObject = { ...data, ...res } 
    dispatch(addEventLog(resObject, CONSTANTS.UPDATE_USER_PROFILE_SUCCESS))
    dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...data, ...err } 
    dispatch(addEventLog(errObject, CONSTANTS.UPDATE_USER_PROFILE_FAILURE))
    dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_FAILURE })
    return err
  })
}

export const sendOtp = (payload) => (dispatch) => {
  dispatch(addEventLog(payload, CONSTANTS.SEND_OTP_REQUEST))
  dispatch({ type: CONSTANTS.SEND_OTP_REQUEST })
  return postRequest(APICONFIG.sendOtpUrl, payload).then((res) => {
    dispatch(addEventLog(res, CONSTANTS.SEND_OTP_SUCCESS))
    dispatch({ type: CONSTANTS.SEND_OTP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    dispatch(addEventLog(err, CONSTANTS.SEND_OTP_FAILURE))
    dispatch({ type: CONSTANTS.SEND_OTP_FAILURE })
    return err
  })
}

export const verifyOtp = (payload) => (dispatch) => {
  dispatch(addEventLog(payload, CONSTANTS.VERIFY_OTP_REQUEST))
  dispatch({ type: CONSTANTS.VERIFY_OTP_REQUEST })
  return postRequest(APICONFIG.verifyOtpUrl, payload).then((res) => {
    dispatch(addEventLog(res, CONSTANTS.VERIFY_OTP_SUCCESS))
    dispatch({ type: CONSTANTS.VERIFY_OTP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    dispatch(addEventLog(err, CONSTANTS.VERIFY_OTP_FAILURE))
    dispatch({ type: CONSTANTS.VERIFY_OTP_FAILURE })
    return err
  })
}

export const sendEmailResetPassword = (payload) => (dispatch) => {
  dispatch(addEventLog(payload, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_REQUEST))
  dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_REQUEST })
  return postRequest(APICONFIG.sendEmailResetPassword, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_SUCCESS))
    dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_FAILURE))
    dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_FAILURE })
    return err
  })
}


// RESET PASSWORD
export const UpdateUserpassword = (payload) => (dispatch) => {
  dispatch(addEventLog(payload, CONSTANTS.RESET_PASSWORD_REQUEST))
  dispatch({ type: CONSTANTS.RESET_PASSWORD_REQUEST })
  return postRequest(APICONFIG.resetPassword, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.RESET_PASSWORD_SUCCESS))
    dispatch({ type: CONSTANTS.RESET_PASSWORD_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.RESET_PASSWORD_FAILURE))
    dispatch({ type: CONSTANTS.RESET_PASSWORD_FAILURE })
    return err
  })
}